<template>
  <div class="inline-flex items-center" :class="{ 'cursor-pointer': !readonly }">
    <button
      v-for="star in 5"
      :key="star"
      type="button"
      class="focus:outline-none transition-colors"
      :class="[sizeClass, readonly ? 'cursor-default' : 'hover:scale-110']"
      :disabled="readonly"
      @click="!readonly && $emit('input', star)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :class="star <= value ? 'text-yellow-400' : 'text-gray-200'"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07
          3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588
          1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921
          -.755 1.688-1.54 1.118l-2.8-2.034a1 1 0
          00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539
          -1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98
          8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0
          00.951-.69l1.07-3.292z"
        />
      </svg>
    </button>
    <span
      v-if="showLabel && value > 0"
      class="ml-1.5 text-gray-500 font-medium"
      :class="labelSizeClass"
    >
      {{ value }}.0
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sizeClass() {
      const map = { sm: 'w-4 h-4', md: 'w-5 h-5', lg: 'w-6 h-6' };
      return map[this.size];
    },
    labelSizeClass() {
      const map = { sm: 'text-[11px]', md: 'text-[12px]', lg: 'text-[14px]' };
      return map[this.size];
    },
  },
};
</script>
